import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactSearchBox from 'shared/design-system/components/TrueImpactSearchBox';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

interface EmailSearchFieldProps {
  className?: string;
  handleSearchEmail: (email: string) => unknown;
}

const StyledDiv = styled.div`
  margin-bottom: ${SPACERS.small};
  .search-field {
    max-width: 600px;
  }
  .search-info {
    margin-top: ${SPACERS.extraTiny};
    margin-left: ${SPACERS.extraTiny};
  }
`;

const EmailSearchField: React.FC<EmailSearchFieldProps> = ({
  className,
  handleSearchEmail,
}) => {
  const [searchEmail, setSearchEmail] = useState<string>('');
  const [error, setError] = useState<string | undefined>(undefined);
  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => setSearchEmail(e.target.value),
    [setSearchEmail],
  );
  const onEnterPress = () => {
    if (searchEmail.length > 4) {
      setError(undefined);
      handleSearchEmail(searchEmail);
    } else {
      handleSearchEmail('');
      setError('Email must be at least 5 characters long');
    }
  };
  const onClear = useCallback(() => {
    handleSearchEmail('');
    setSearchEmail('');
  }, [handleSearchEmail, setSearchEmail]);
  return (
    <StyledDiv className={className}>
      <TrueImpactSearchBox
        type="email"
        value={searchEmail}
        onClear={onClear}
        placeholder="Search by email"
        onEnterPress={onEnterPress}
        onChange={onChange}
        className="search-field"
      />
      <TrueImpactText
        variant="body-small"
        className="search-info"
        color={error ? 'critical' : 'grayDark'}
      >
        {error || 'Press enter to search'}
      </TrueImpactText>
    </StyledDiv>
  );
};

export default React.memo(EmailSearchField);
